export var Scope;

(function (Scope) {
  Scope["SINGLETON"] = "SINGLETON";
  Scope["TRANSIENT"] = "TRANSIENT";
})(Scope || (Scope = {}));

export var DEFAULT_INJECTION_CONTEXT = Object.freeze({
  id: '1'
});
export function createInjectionContext() {
  return {
    id: Math.random().toString()
  };
}